import handler from "../middleware/HttpHandler";

const API_URL = process.env.REACT_APP_API_URL;

const handleResponse = async (response, shouldThrow = false) => {
  if (!response) {
    if (shouldThrow) throw new Error("Please check your internet connection.");
    return undefined;
  }

  if (!response.ok) {
    handler(response);

    if (shouldThrow) {
      throw new Error("Something went wrong. Please try again.");
    }

    return undefined;
  }

  const data = await response.json();

  if (data?.error) {
    if (shouldThrow) throw new Error(data.error);
    return undefined;
  }

  return data;
};


const sendAuthRequest = async (path, body, signal) => {
  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      signal, // ← add
    });

    return await handleResponse(response, true);
  } catch (err) {
    if (err.name === "AbortError") return undefined;
    handler(err);
    throw err;
  }
};


const sendPostRequest = async (path, body, context, signal) => { 
  const headers = {
    "Content-Type": "application/json",
  };

  if (context?.token) {
    headers.Authorization = `Bearer ${context.token}`;
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
      signal, 
    });

    return await handleResponse(response, true);
  } catch (err) {
    if (err.name === "AbortError") return undefined; 
    handler(err);
    throw err;
  }
};

const sendPostFormDataRequest = async (path, formData, context) => {
  const headers = {};

  if (context?.token) {
    headers.Authorization = `Bearer ${context.token}`;
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "POST",
      headers,
      body: formData,
    });

    return await handleResponse(response, true);
  } catch (err) {
    handler(err);
    throw err;
  }
};

const sendFormDataRequest = async (path, formData, context, signal) => {
  const headers = {};

  if (context?.token) {
    headers.Authorization = `Bearer ${context.token}`;
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "POST",
      headers,
      body: formData,
      signal, 
    });

    return await handleResponse(response, true);
  } catch (err) {
    if (err.name === "AbortError") return undefined;
    handler(err);
    throw err;
  }
};

const sendPutRequest = async (path, context) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (context?.token) {
    headers.Authorization = `Bearer ${context.token}`;
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "PUT",
      headers,
    });

    return await handleResponse(response, true);
  } catch (err) {
    handler(err);
    throw err;
  }
};


const sendPutRequestWithBody = async (path, body, context) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (context?.token) {
    headers.Authorization = `Bearer ${context.token}`;
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(body),
    });

    return await handleResponse(response, true);
  } catch (err) {
    handler(err);
    throw err;
  }
};

  const sendRequest = async (path, token, signal) => {
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(`${API_URL}${path}`, {
        method: "GET",
        headers,
        signal, 
      });

      return await handleResponse(response, false);
    } catch (err) {
      if (err.name === "AbortError") return undefined; 
      handler(err);
      return undefined;
    }
  };

const sendUnAuthRequest = async (path) => {
  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "GET",
    });

    return await handleResponse(response, false);
  } catch (err) {
    handler(err);
    return undefined;
  }
};


const sendDeleteRequest = async (path, token) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "DELETE",
      headers,
    });

    return await handleResponse(response, true);
  } catch (err) {
    handler(err);
    throw err;
  }
};

const sendUnAuthPostRequest = async (path, body, signal) => {
  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      signal, // ← add
    });

    return await handleResponse(response, true);
  } catch (err) {
    if (err.name === "AbortError") return undefined;
    handler(err);
    throw err;
  }
};

const sendUnAuthPostFormDataRequest = async (path, formData) => {
  try {
    const response = await fetch(`${API_URL}${path}`, {
      method: "POST",
      body: formData,
    });

    return await handleResponse(response, true);
  } catch (err) {
    handler(err);
    throw err;
  }
};

const request = {
  sendAuthRequest,
  sendPostRequest,
  sendPostFormDataRequest,
  sendFormDataRequest,
  sendPutRequest,
  sendPutRequestWithBody,
  sendRequest,
  sendUnAuthRequest,
  sendDeleteRequest,
  sendUnAuthPostRequest,
  sendUnAuthPostFormDataRequest,
};

export default request;